module.exports = __webpack_public_path__ + "static/media/Water_Pump.b76240a6.png";